/**
 * Page /cart — mise à jour des quantités (AJAX /cart/change.js) et tunnel de
 * commande COD (mêmes principes que assets/quick-order.js sur la fiche
 * produit, mais pour l'ensemble des articles du panier).
 */
(function () {
  var ORDER_ENDPOINT = '/apps/quick-order/orders';

  function formatMoney(v) { return (Number(v) || 0).toFixed(2) + ' DT'; }

  // Livraison offerte dès un montant : seuil = metafield boutique
  // custom.free_shipping_threshold, exposé sur #CartOrderFreeShipping.
  // Le backend applique la même règle côté serveur.
  function applyFreeShipping(subtotal, delivery, threshold) {
    threshold = parseFloat(threshold) || 0;
    return threshold > 0 && subtotal >= threshold ? 0 : delivery;
  }
  function freeShippingHint(el, subtotal, threshold) {
    if (!el) return;
    threshold = parseFloat(threshold) || 0;
    if (threshold <= 0) { el.hidden = true; return; }
    var remaining = threshold - subtotal;
    el.textContent = remaining > 0
      ? 'Plus que ' + formatMoney(remaining) + ' pour la livraison offerte'
      : 'Livraison offerte';
    el.classList.toggle('is-reached', remaining <= 0);
    el.hidden = false;
  }

  // On agit par numéro de ligne (et non par variante) : un même produit peut
  // apparaître deux fois, une fois seul et une fois en pack.
  function changeQuantity(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function () { window.location.reload(); });
  }

  function initQuantityControls() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var line = parseInt(row.dataset.line, 10);
      var step = parseInt(row.dataset.step, 10) || 1; // pas d'un pack (1 pour un article normal)
      var input = row.querySelector('.cart-qty-input');
      var minus = row.querySelector('.cart-qty-minus');
      var plus = row.querySelector('.cart-qty-plus');
      var remove = row.querySelector('.cart-item__remove');

      if (minus) minus.addEventListener('click', function () {
        var qty = Math.max(0, (parseInt(input.value, 10) || step) - step);
        changeQuantity(line, qty);
      });
      if (plus) plus.addEventListener('click', function () {
        var qty = (parseInt(input.value, 10) || step) + step;
        changeQuantity(line, qty);
      });
      if (remove) remove.addEventListener('click', function () {
        var group = row.dataset.group;
        if (!group) return changeQuantity(line, 0);
        // Pack de plusieurs articles : on retire toutes ses lignes d'un coup.
        var updates = {};
        document.querySelectorAll('.cart-item').forEach(function (r) {
          if (r.dataset.group === group) updates[r.dataset.key] = 0;
        });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () { window.location.reload(); });
      });
    });
  }

  function initOrderPanel() {
    var submitBtn = document.getElementById('CartOrderSubmit');
    if (!submitBtn) return;

    var itemsEl = document.getElementById('CartItemsJSON');
    var items = [];
    try { items = JSON.parse(itemsEl.textContent); } catch (e) { items = []; }

    var delivery = items.reduce(function (max, item) { return Math.max(max, Number(item.delivery) || 0); }, 0);
    var subtotal = items.reduce(function (sum, item) { return sum + (item.price * item.quantity); }, 0);
    var freeShippingEl = document.getElementById('CartOrderFreeShipping');
    var threshold = freeShippingEl ? freeShippingEl.dataset.freeShippingThreshold : 0;
    delivery = applyFreeShipping(subtotal, delivery, threshold);
    var total = subtotal + delivery;
    freeShippingHint(freeShippingEl, subtotal, threshold);

    var subtotalEl = document.getElementById('CartOrderSubtotal');
    var deliveryEl = document.getElementById('CartOrderDelivery');
    var totalEl = document.getElementById('CartOrderTotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (deliveryEl) deliveryEl.textContent = delivery > 0 ? formatMoney(delivery) : 'Offerte';
    if (totalEl) totalEl.textContent = formatMoney(total);

    var errorEl = document.getElementById('CartOrderError');

    submitBtn.addEventListener('click', function () {
      errorEl.style.display = 'none';

      // Les lignes d'un même pack (même bundle_group) partent ensemble :
      // une ligne { bundle_id, bundle_variants: [une variante par article] }.
      var lineItems = [];
      var packs = {};
      items.forEach(function (item) {
        if (!item.bundle_group) {
          lineItems.push({ variant_id: item.variant_id, quantity: item.quantity, bundle_id: item.bundle_id || undefined });
          return;
        }
        var pack = packs[item.bundle_group];
        if (!pack) {
          pack = packs[item.bundle_group] = { bundle_id: item.bundle_id, bundle_variants: [] };
          lineItems.push(pack);
        }
        for (var i = 0; i < item.quantity; i++) pack.bundle_variants.push(item.variant_id);
      });

      var payload = {
        shop_domain: window.Shopify ? Shopify.shop : '',
        line_items: lineItems,
        customer: {
          name: (document.getElementById('CartOrderName').value || '').trim(),
          phone: (document.getElementById('CartOrderPhone').value || '').trim(),
          city: document.getElementById('CartOrderCity').value,
          address: (document.getElementById('CartOrderAddress').value || '').trim(),
        },
      };

      if (!payload.customer.name || !payload.customer.phone || !payload.customer.address) {
        errorEl.textContent = 'Merci de remplir le nom, le téléphone et l\'adresse.';
        errorEl.style.display = 'block';
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Envoi en cours…';

      fetch(ORDER_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('request_failed');
          return res.json();
        })
        .then(function (data) {
          var receipt = {
            orderNumber: data.order_number,
            items: items.map(function (item) {
              return { title: item.title, variant: item.variant, image: item.image, price: item.price, quantity: item.quantity };
            }),
            subtotal: subtotal,
            delivery: delivery,
            total: total,
            customer: payload.customer,
          };
          var encoded = btoa(unescape(encodeURIComponent(JSON.stringify(receipt))));
          var thanksUrl = '/pages/merci?r=' + encodeURIComponent(encoded);
          // Commande passée : on vide le panier pour éviter une double commande.
          fetch('/cart/clear.js', { method: 'POST' })
            .catch(function () {})
            .then(function () { window.location.href = thanksUrl; });
        })
        .catch(function () {
          errorEl.textContent = 'Une erreur est survenue, merci de réessayer ou de nous contacter.';
          errorEl.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Acheter maintenant';
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initQuantityControls();
    initOrderPanel();
  });
})();
